import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import Loader from "../../components/shared/Loader/Loader";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";

function FooterPage() {
  const { footerApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(footerApi);
  const [filteredData, setFilteredData] = useState({});

  // filter by slug
  useEffect(() => {
    setFilteredData(apiData.filter((item) => item.slug === "footer")[0]);
  }, [apiData]);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const { logo, logoSlogan, socialMedia, _id } = filteredData ?? {};

  // map socials
  const socialLinksData = [];
  socialMedia?.map((item, index) => {
    socialLinksData.push({
      label: `Social Links ${index + 1}`,
      type: "text",
      name: "socialMedia",
      defaultValue: item,
    });
  });

  // Form data
  const data = [];

  const multiDimensionalDataText = [
    {
      elementType: "nested",
      label: "Social Links",
      name: "socialMedia",
      multipleData: socialLinksData,
      multiple: true,
      required: false,
    },
  ];

  const useData = data.concat(multiDimensionalDataText);

  const update = (data) => {
    let socialMedia = [];
    data?.socialMedia?.map((item) =>
      socialMedia.push({ link: item[1], name: item[0] })
    );
    const newData = {
      socialMedia: socialMedia,
    };
    updateData(footerApi, newData, _id);
  };

  return (
    <div>
      {_id && (
        <GlobalForm
          data={useData}
          multiDimensionalDataText={multiDimensionalDataText}
          update={update}
        />
      )}
    </div>
  );
}

export default FooterPage;
